export default __webpack_public_path__ + "static/media/background.ba589f52.svg";